@if (state.config.betsConfig.qualifiers) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Qualifier ({{ state.config.betsConfig.qualifiers.points }})</mat-card-title>
      <mat-card-subtitle>Playoff's stage qualifiers</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.qualifiersOptions"
                            [initValue]="state.betting?.qualifiers"
                            [key]="'qualifiers'"
                            [multi]="false"
                            [multipleDropdowns]="true">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.underOver) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Under over ({{ state.config.betsConfig.underOver.points }})</mat-card-title>
      <mat-card-subtitle>Total number of goals during the stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-button-group-betting [bettingForm]="state.bettingForm"
                               [initValue]="state.betting?.underOver"
                               [key]="'underOver'"
                               [options]="state.underOverOptions">
      </oo-button-group-betting>
    </mat-card-content>
  </mat-card>
}
